export const activitySectors: string[] = [
  "Services à la personne", // personService
  "Agence de femme de ménage", // cleaningAgency
  "Agence immobilière Gestion Locative", // realEstateRentalAgency
  "Agence immobilière Syndic de co-propriété", // realEstateSyndicAgency
  "Groupe immobilier", // realEstateGroup
  "Bailleurs sociaux", // socialDonors
  "Property Management", // propertyManagement
  "Constructeur", // manufacturer
  "Maître d’oeuvre", // masterOfWork
  "Artisan", // craftsman
  "Assurance", // insurance
  "Conciergerie Airbnb", // airbnbService
  "Concessionnaire auto", // carDealer
  "Autre", // other
];
